module.exports = __webpack_public_path__ + "static/media/canalOff.d3c1f2c5.png";